module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_eyegames.ab13eed44e10d8fda6886a75d2abe29f.png";